import {ERROR, POST1} from './api'

const DEFAULT_LOG_BIZ_NAME = 'ERROR_SPL_SMYQ_HEXIAOYANQ'

const state = {
    queue: [],
    timer: null,
    running: false,
}

function nowText() {
    const date = new Date()
    const pad = value => String(value).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

function clone(data) {
    if (!data) return data
    try {
        return JSON.parse(JSON.stringify(data))
    } catch (err) {
        return data
    }
}

function getTicketKey(item = {}) {
    if (item.verifyId) return `verifyId:${item.verifyId}`
    if (item.receiptCode) return `receiptCode:${item.receiptCode}`
    return ''
}

function getOrderVerifyTicketKeys(orderVerifyList = []) {
    const keys = new Set()
    const safeList = Array.isArray(orderVerifyList) ? orderVerifyList : []
    safeList.forEach(item => {
        [
            item,
            item.meituanConsume,
            item.douyinConsume
        ].forEach(source => {
            if (!source) return
            const key = getTicketKey(source)
            if (key) keys.add(key)
        })
    })
    return keys
}

function getMissingTickets(tickets = [], orderVerifyList = []) {
    const boundKeys = getOrderVerifyTicketKeys(orderVerifyList)
    return (Array.isArray(tickets) ? tickets : []).filter(item => {
        const key = getTicketKey(item)
        return key && !boundKeys.has(key)
    })
}

function getBindApi(ticket = {}) {
    return ticket.type === '美团'
        ? '/abutment/groupPurchase/connectOrUnConnectOrder'
        : '/abutment/verify/connectOrUnConnectOrder'
}

function getErrorMessage(err) {
    if (!err) return ''
    return String(
        err.msg ||
        err.errorMsg ||
        err.errorMessage ||
        err.name ||
        err.message ||
        (err.response && err.response.data && (err.response.data.msg || err.response.data.message)) ||
        ''
    )
}

function isDuplicateError(err) {
    const message = getErrorMessage(err)
    const code = err && (err.code || err.status || err.errorCode)
    return Number(code) === 5002
        || message.includes('数据重复')
        || message.includes('请勿重复添加数据')
        || message.includes('已绑定')
        || message.includes('重复')
        || message.includes('已存在')
}

async function reportLog(task, payload = {}) {
    const basePayload = clone(task.logContext || {})
    const logPayload = {
        ...basePayload,
        logTime: nowText(),
        stage: '后台补绑队列',
        ...payload
    }
    try {
        await ERROR('customer/log/error', {
            bizName: task.bizName || DEFAULT_LOG_BIZ_NAME,
            fields: JSON.stringify(logPayload)
        })
    } catch (logErr) {
        console.error('yanquan bind queue log failed', logErr)
    }
}

async function fetchOrderInfo(orderId) {
    const res = await POST1('/customer/EomsOrder/findEomsOrderById', {id: orderId}, false, '', false, false)
    return res && res.data ? res.data : null
}

async function requestBindTicket(ticket, orderId) {
    const param = {
        ...ticket,
        operation: 1,
        orderId,
        verifyId: ticket.verifyId || ''
    }
    const bindApi = getBindApi(param)
    const responseData = await POST1(bindApi, param, false, '', false, false)
    return {
        bindApi,
        requestData: clone(param),
        responseData: clone(responseData)
    }
}

async function bindTicketWithRetry(task, ticket, index) {
    const maxRetryTimes = 3
    let lastError = null
    for (let attempt = 1; attempt <= maxRetryTimes; attempt++) {
        try {
            const result = await requestBindTicket(ticket, task.orderId)
            await reportLog(task, {
                status: '后台补绑单券成功',
                message: '后台补绑队列单张券绑定成功',
                bindApi: result.bindApi,
                requestData: result.requestData,
                responseData: result.responseData,
                bindInfo: {
                    orderId: task.orderId,
                    bindIndex: index,
                    bindAttempt: attempt,
                    goodsName: ticket.goodsName || '',
                    type: ticket.type || '',
                    receiptCode: ticket.receiptCode || '',
                    verifyId: ticket.verifyId || ''
                }
            })
            return {success: true}
        } catch (err) {
            lastError = err
            if (isDuplicateError(err)) {
                await reportLog(task, {
                    status: '后台补绑重复跳过',
                    message: '后台补绑发现券码已绑定，按成功处理',
                    bindInfo: {
                        orderId: task.orderId,
                        bindIndex: index,
                        bindAttempt: attempt,
                        goodsName: ticket.goodsName || '',
                        type: ticket.type || '',
                        receiptCode: ticket.receiptCode || '',
                        verifyId: ticket.verifyId || ''
                    },
                    error: clone(err)
                })
                return {success: true, skipped: true}
            }
            await reportLog(task, {
                status: attempt < maxRetryTimes ? '后台补绑单券重试' : '后台补绑单券失败',
                message: attempt < maxRetryTimes ? '后台补绑单张券失败，准备重试' : '后台补绑单张券最终失败',
                bindInfo: {
                    orderId: task.orderId,
                    bindIndex: index,
                    bindAttempt: attempt,
                    goodsName: ticket.goodsName || '',
                    type: ticket.type || '',
                    receiptCode: ticket.receiptCode || '',
                    verifyId: ticket.verifyId || ''
                },
                error: clone(err)
            })
            if (attempt < maxRetryTimes) {
                await new Promise(resolve => setTimeout(resolve, 800))
            }
        }
    }
    return {success: false, error: lastError}
}

async function runTask(task) {
    await reportLog(task, {
        status: '后台补绑开始',
        message: '后台补绑队列开始检查订单券码绑定状态',
        bindInfo: {
            orderId: task.orderId,
            enqueueReason: task.reason || '',
            expectedTotal: Array.isArray(task.tickets) ? task.tickets.length : 0,
            tickets: task.tickets || []
        }
    })

    const orderInfo = await fetchOrderInfo(task.orderId)
    const missingTickets = getMissingTickets(task.tickets, orderInfo && orderInfo.orderVerifyList)
    await reportLog(task, {
        status: missingTickets.length ? '发现漏绑' : '回查无漏绑',
        message: missingTickets.length ? '后台队列回查发现券码未绑定，准备补绑' : '后台队列回查确认本次券码已全部绑定',
        bindInfo: {
            orderId: task.orderId,
            expectedTotal: Array.isArray(task.tickets) ? task.tickets.length : 0,
            serverBoundTotal: Array.isArray(orderInfo && orderInfo.orderVerifyList) ? orderInfo.orderVerifyList.length : 0,
            missingTotal: missingTickets.length,
            missingTickets
        }
    })
    if (!missingTickets.length) return

    const failures = []
    for (let i = 0; i < missingTickets.length; i++) {
        const result = await bindTicketWithRetry(task, missingTickets[i], i)
        if (!result.success) {
            failures.push({
                ticket: missingTickets[i],
                error: clone(result.error)
            })
        }
    }

    const refreshedOrderInfo = await fetchOrderInfo(task.orderId)
    const stillMissingTickets = getMissingTickets(task.tickets, refreshedOrderInfo && refreshedOrderInfo.orderVerifyList)
    await reportLog(task, {
        status: stillMissingTickets.length ? '自动补绑后仍缺失' : '自动补绑成功',
        message: stillMissingTickets.length ? '后台补绑后回查仍有券码缺失' : '后台补绑后回查确认券码已绑定',
        bindInfo: {
            orderId: task.orderId,
            remedyBindTotal: missingTickets.length,
            failedTotal: failures.length,
            failures,
            stillMissingTotal: stillMissingTickets.length,
            stillMissingTickets
        }
    })
}

function scheduleFlush(delay = 1500) {
    if (state.timer) return
    state.timer = setTimeout(() => {
        state.timer = null
        flushYanQuanBindQueue()
    }, Math.max(0, delay))
}

export function enqueueYanQuanBindRemedy(task = {}, options = {}) {
    if (!task.orderId || !Array.isArray(task.tickets) || !task.tickets.length) return
    state.queue.push({
        ...task,
        tickets: clone(task.tickets)
    })
    scheduleFlush(options.delay)
}

export async function flushYanQuanBindQueue() {
    if (state.running) return
    state.running = true
    try {
        while (state.queue.length) {
            const task = state.queue.shift()
            try {
                await runTask(task)
            } catch (err) {
                await reportLog(task, {
                    status: '后台补绑异常',
                    message: '后台补绑队列任务异常',
                    bindInfo: {
                        orderId: task.orderId,
                        expectedTotal: Array.isArray(task.tickets) ? task.tickets.length : 0
                    },
                    error: clone(err)
                })
            }
            if (state.queue.length) {
                await new Promise(resolve => setTimeout(resolve, 300))
            }
        }
    } finally {
        state.running = false
        if (state.queue.length) {
            scheduleFlush(1500)
        }
    }
}
